var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/open-question",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(4.000000, 4.000000)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,9 C10.0002913,7.47442919 11.1454538,6.19201013 12.6612688,6.01975736 C14.1770839,5.8475046 15.5807925,6.84027747 15.9233788,8.32688466 C16.2659652,9.81349185 15.438322,11.3204764 14,11.829 C13.4004081,12.0409876 12.9996666,12.6080369 13,13.244",
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,16.25 C12.7928932,16.25 12.625,16.4178932 12.625,16.625 C12.625,16.8321068 12.7928932,17 13,17 C13.2071068,17 13.375,16.8321068 13.375,16.625 C13.375,16.4178932 13.2071068,16.25 13,16.25 L13,16.25",
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75,0.749981392 C8.93932847,0.744505526 5.42568259,2.8069362 3.57279712,6.13681054 C1.71991166,9.46668489 1.81953469,13.539694 3.833,16.775 L0.75,23.25 L7.224,20.166 C11.0101174,22.5209314 15.8706393,22.2278896 19.3464019,19.435138 C22.8221645,16.6423864 24.1550978,11.9590291 22.6708089,7.75459411 C21.18652,3.55015911 17.208735,0.741641192 12.75,0.749981392 L12.75,0.749981392 Z",
    id: "path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenQuestion);
export default __webpack_public_path__ + "static/media/open-question.0d2b5e5f52bc09833ef9fc082eeb0d01.svg";
export { ForwardRef as ReactComponent };